(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cmw-floating-buttons"] && !Shopify.designMode) return;
  try {
    function initCmwFloatingButtons() {
    var roots = document.querySelectorAll('[data-cmw-floating-buttons-root]');

    roots.forEach(function(root, index) {
      if (index < roots.length - 1) {
        root.remove();
      }
    });

    if (window.cmwFloatingButtonsInitialized) {
      return;
    }

    window.cmwFloatingButtonsInitialized = true;

    function closeOpenGroups(exceptDetails) {
      document.querySelectorAll('[data-cmw-floating-buttons-root] details[open]').forEach(function(details) {
        if (details !== exceptDetails) {
          details.removeAttribute('open');
        }
      });
    }

    function updateSuspendedState() {
      var isModalOpen = Boolean(document.querySelector('.mfp-wrap'));
      var isPromoOpen = Boolean(document.querySelector('.js-promo-pop.js-active'));

      document.querySelectorAll('[data-cmw-floating-buttons-root]').forEach(function(root) {
        root.setAttribute('data-cmw-floating-buttons-suspended', isModalOpen || isPromoOpen ? 'true' : 'false');
      });
    }

    document.addEventListener('toggle', function(event) {
      if (!event.target.matches('[data-cmw-floating-buttons-root] details')) {
        return;
      }

      if (event.target.open) {
        closeOpenGroups(event.target);
      }
    }, true);

    document.addEventListener('click', function(event) {
      document.querySelectorAll('[data-cmw-floating-buttons-root] details[open]').forEach(function(details) {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') {
        return;
      }

      closeOpenGroups();
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(updateSuspendedState);
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true
      });
    }

    updateSuspendedState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCmwFloatingButtons);
  } else {
    initCmwFloatingButtons();
  }
  } catch(e) { console.error(e); }
})();

})();
